import { createSlice } from '@reduxjs/toolkit';
import { loadTranslation } from './thunks/loadTranslation.thunk';
import {
  showOriginalText,
  showTranslatedText,
} from './actions/translations.actions';

export const translationsSlice = createSlice({
  name: 'translations',
  initialState: {
    translationsByLanguageCode: {},
    targetsWithTranslationEnabled: [],
    targetsWithTranslationAttempted: [],
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(loadTranslation.fulfilled, (state, action) => {
        if (action.payload) {
          const { targetId, translatedText, targetLanguageCode } =
            action.payload;
          if (!state.translationsByLanguageCode[targetLanguageCode]) {
            state.translationsByLanguageCode[targetLanguageCode] = {};
          }
          if (translatedText) {
            state.translationsByLanguageCode[targetLanguageCode][targetId] =
              translatedText;
            state.targetsWithTranslationEnabled.push(targetId);
          }
          state.targetsWithTranslationAttempted.push(targetId);
        }
      })
      .addCase(showOriginalText, (state, action) => {
        const newTargetsWithTranslationEnabled =
          state.targetsWithTranslationEnabled.filter(
            (targetId) => targetId !== action.payload
          );
        state.targetsWithTranslationEnabled = newTargetsWithTranslationEnabled;
      })
      .addCase(showTranslatedText, (state, action) => {
        state.targetsWithTranslationEnabled.push(action.payload);
      });
  },
});
